import React, {Component} from 'react';
import {SVGIcon} from '@homeaway/react-svg';
import {HOUSE__24} from '@homeaway/svg-defs';

export class Thumbnail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imageLoaded: false,
            imageErrorOrMissing: false || !props.thumbnailUrl
        };
        this.imgRef = React.createRef();
    }

    componentDidMount() {
        // check for cached image that won't trigger onLoad
        if (
            this.imgRef.current &&
            this.imgRef.current.complete &&
            !this.state.imageLoaded
        ) {
            this.setImageLoaded();
        }
    }

    setImageLoaded = () => this.setState({imageLoaded: true});

    handleLoad = () => this.setImageLoaded();

    handleError = () => this.setState({imageErrorOrMissing: true});

    renderImagePlaceholder = () => {
        const {imageLoaded, imageErrorOrMissing} = this.state;
        return imageErrorOrMissing || !imageLoaded ? (
            <div className="result__listing-placeholder-container">
                <SVGIcon
                    className="result__listing-placeholder"
                    markup={HOUSE__24}
                />
            </div>
        ) : null;
    };

    render() {
        const {imageLoaded, imageErrorOrMissing} = this.state;
        const {thumbnailUrl} = this.props;
        const imageProps = {
            className: 'result__listing-image',
            src: thumbnailUrl,
            width: 48,
            height: 48
        };

        // image for loading/error detection
        return (
            <>
                {!imageLoaded && !imageErrorOrMissing && (
                    <img
                        {...imageProps}
                        alt=""
                        ref={this.imgRef}
                        onLoad={this.handleLoad}
                        onError={this.handleError}
                        className="result__listing-image-loader"
                    />
                )}
                {imageLoaded && <img {...imageProps} alt="" />}
                {this.renderImagePlaceholder()}
            </>
        );
    }
}
